<template>
    <form action="">
        <div class="modal-card">
            <header class="modal-card-head">
                <p class="modal-card-title">
                    {{ headerText }}
                </p>
            </header>
            <section class="modal-card-body">
                <o-field label="Contact" :type="fieldType('contactId')">
                    <multicomplete v-model="email.contact" type="contact" placeholder="Select Contacts"
                        field-name="full_name" track="id" :max="1" :is-object="true" :value="email.contact"
                        :error="getError('contactId')" />
                </o-field>

                <o-field label="CC Contacts">
                    <multicomplete v-model="email.contacts" type="contact" placeholder="Select Contacts"
                        field-name="full_name" track="id" :is-object="true" :limit="99" />
                </o-field>

                <o-field label="BCC Users">
                    <multicomplete v-model="email.users" type="user" placeholder="Select Users" field-name="full_name"
                        track="id" :is-object="true" />
                </o-field>

                <o-field label="Subject" :type="fieldType('subject')" :message="getError('subject')">
                    <o-input v-model="email.subject" />
                </o-field>

                <div class="field">
                    <!--                    <b-quill v-model="email.message" :error="getError('message')" />-->
                    <quill-editor v-model:content="email.message" :content-type="'html'" :error="getError('message')" />
                </div>

                <div class="columns" style="align-items: center;">
                    <div class="column">
                        <!--                        <div class="field">-->
                        <!--                            <o-checkbox v-model="email.with_pdf">Attach PDF</o-checkbox>-->
                        <!--                        </div>-->
                        <p v-if="context === 'project-pm-assigned-message'" class="field">
                            <b>PIS pdf will be attached automatically</b>
                        </p>
                    </div>
                    <div class="column">
                        <p class="control has-text-right">
                            <uploadcare ref="ucare" v-model="email.files" format="object" :multiple="true" />
                        </p>
                    </div>
                </div>
                <div v-if="isReminderMessage">
                    <hr>
                    <o-checkbox v-model="showFollowUpReminder">
                        Create a reminder to follow up
                    </o-checkbox>
                    <datepicker v-if="showFollowUpReminder" v-model="followUpReminder" :config="{ minDate: 'today' }" />
                </div>
            </section>
            <footer class="modal-card-foot">
                <button class="button" type="button" @click="$parent.$parent.$emit('update:active', false)">
                    Close
                </button>
                <button v-submit="submitting" :disabled="!email.contact || submitting" class="button is-primary"
                    @click.prevent="handleSendEmail">
                    Send
                    <i v-if="submitting" class="fa fa-spinner fa-spin loading-icon fa-2x fa-fw" />
                </button>
            </footer>
        </div>
    </form>
</template>

<script>
import { QuillEditor } from "@vueup/vue-quill"
import { mapActions, mapGetters } from 'vuex'
import { server_login } from "../../modules/emails/gmail_api"
import Datepicker from '../Datepicker.vue'
import HandlesForm from './../../mixins/HandlesForm'
import Multicomplete from './../Multicomplete'
import Uploadcare from './../Uploadcare'

// todo 'change-order-message' context was removed from the code
export default {

    components: {
        QuillEditor,
        Multicomplete,
        Uploadcare,
        Datepicker
    },
    mixins: [HandlesForm],

    props: {
        entity: {
            type: Object,
            required: true
        },
        entityType: {
            type: String,
            default: 'proposal'
        },
        context: {
            type: String
        },
        isReminder: {
            type: Boolean
        },
        closable: {
            type: Boolean,
            default: true
        },
        locService: {
            type: Object
        },
    },
    data() {
        return {
            submitting: false,
            email: {
                with_pdf: true,
                files: [],
                subject: '',
                contact: [],
                contacts: [],
                users: [],
                text: ''
            },
            showFollowUpReminder: false,
            followUpReminder: null
        }
    },

    computed: {
        ...mapGetters([
            'projectPmAssignedMessage',
            'proposalInitialMessage',
            'proposalRequestSignatureMessage',
            'proposalReminderMessage',
            'changeOrderMessage',
            'changeOrderRemindMessage',
            'negativeChangeOrderMessage',
            'proposalRemindMessage',
            'projectLocEmailMessage',
            'projectContactsByProjectId',
            'contactsByCompanyId',
            'currentProject',
            'contactById',
            'userById',
        ]),

        isEntityProposal() {
            return this.entityType === 'proposal'
        },

        isEntityProject() {
            return this.entityType == 'project'
        },

        headerText() {
            return this.context === 'proposal-request-signature-message' || this.context == 'change-order-message' || this.context == 'negative-change-order-message' ? 'Request Signature' : 'Send Message'
        },

        isRequestSignatureMessage() {
            return this.context == 'proposal-request-signature-message'
        },
        isChangeOrderReminder() {
            return this.context == 'change-order-remind-message'
        },
        isProposalReminder() {
            return this.context == 'proposal-remind-message'
        },
        isReminderMessage() {
            return this.isChangeOrderReminder || this.isProposalReminder
        }
    },

    mounted() {
        console.log(this.entity);
        if (this.entity.contacts && this.entity.contacts.length === 1 && this.entity.billed_to_contact) {
            this.entity.contact_id = this.entity.contacts[0]
            this.entity.billed_to_contact = this.entity.billed_to_contacts[0]
        }
        // todo message template should be filled based off the context
        this.email.message = this.getMessageTemplate()
        this.email.subject = this.getMessageSubject()

        if (this.entity.contact_id) {
            let contact = this.contactById(this.entity.contact_id)

            if (contact) {
                this.email.contact.push(contact)
            }
        }
        if (this.isChangeOrderReminder) {
            this.email.users.push(this.userById(this.entity.created_by))
            this.email.users.push(this.userById(this.currentProject.assigned_to))
        }

        this.fetchContacts()
        this.fetchUsers()
    },

    methods: {
        ...mapActions([
            'sendChangeOrderEmail',
            'sendChangeOrderRemindEmail',
            'sendProposalEmail',
            'sendProjectEmail',
            'fetchContacts',
            'processProposal',
            'processChangeOrder',
            'scheduleLocEmail',
            'fetchContacts',
            'fetchUsers'
        ]),

        getMessageTemplate() {
            let map = {
                'project-pm-assigned-message': this.projectPmAssignedMessage,
                'proposal-initial-message': this.proposalInitialMessage,
                'proposal-request-signature-message': this.proposalRequestSignatureMessage,
                'proposal-reminder-message': this.proposalReminderMessage,
                'change-order-message': this.changeOrderMessage,
                'change-order-remind-message': this.changeOrderRemindMessage,
                'negative-change-order-message': this.negativeChangeOrderMessage,
                'proposal-remind-message': this.proposalRemindMessage,
                'loc-email-message': this.projectLocEmailMessage
            }

            return map[this.context]
        },

        getMessageSubject() {
            let subjectParts = []

            if (this.isEntityProposal) {
                subjectParts.push('Service Proposal')
                if (this.entity.address) subjectParts.push(this.entity.address)
                if (this.entity.project_name) subjectParts.push(this.entity.project_name)
            } else if (this.isEntityProject) {
                if (this.entity.full_name) subjectParts.push(this.entity.full_name)
                this.email.subject = subjectParts.join(' - ')
                this.email.with_pdf = false
            } else {
                if (this.context === 'change-order-message') {
                    subjectParts.push('Change Order')
                } else {
                    subjectParts.push('Negative Change Order')
                }
                if (this.currentProject.address) subjectParts.push(this.currentProject.address)
                if (this.currentProject.name) subjectParts.push(this.currentProject.name)
            }

            return subjectParts.join(' - ')
        },

        handleSendEmail() {
            let handler = this.isEntityProposal
                ? this.sendProposalEmail
                : (this.isEntityProject ? this.sendProjectEmail : this.sendChangeOrderEmail)

            let submit = this.wrapSubmit(handler),
                contactId = _.map(this.email.contact, 'id'),
                contactIds = _.map(this.email.contacts, 'id'),
                userIds = _.map(this.email.users, 'id'),
                withPdf = this.email.with_pdf

            let postData = {
                withPdf,
                contactId,
                contactIds,
                userIds,
                subject: this.email.subject,
                message: this.email.message,
                entityIdProperty: this.entity.id,
                files: this.email.files,
                isReminder: this.isReminder,
                fromRemindBy: this.isReminderMessage,
                followUpReminder: this.showFollowUpReminder ? this.followUpReminder : null
            }

            postData[`${this.entityType}_id`] = this.entity.id

            submit(postData)
                .then(res => {
                    switch (res.data.type) {
                        case 'proposal':
                            this.processProposal(res.data.data)
                            break
                        case 'change-order':
                            this.processChangeOrder(res.data.data)
                            break
                    }
                    if (this.locService) {
                        this.scheduleLocEmail({ id: this.locService.id, loc_send_date: null })
                    }

                    this.successMessage('Message has been sent')
                    this.$refs.ucare.clear()
                    this.$parent.$parent.$emit('update:active', false)
                    setTimeout(() => {
                        window.location.reload()
                    }, 1000)
                    return res
                })
                .catch((err) => {
                    if (err.response.status === 401 || err.response.status === 400) {
                        this.errorMessage('log in to your gmail account and try again')
                        server_login()
                        return err
                    }
                })
        }
    }
}
</script>
